module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aU4A7"))).then(() => parcelRequire('hEqeo'));